import { render, staticRenderFns } from "./IAQChartView.vue?vue&type=template&id=deb936a4&scoped=true&class=fill-height"
import script from "./IAQChartView.vue?vue&type=script&lang=ts"
export * from "./IAQChartView.vue?vue&type=script&lang=ts"
import style0 from "./IAQChartView.vue?vue&type=style&index=0&id=deb936a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb936a4",
  null
  
)

export default component.exports